export enum LoaderState {
  PENDING = 'PENDING',
  FULFILLED = 'FULFILLED',
  REJECT = 'REJECT',
}
